import { Actions } from '../actions/Actions';

const initState = {
  DisplayName: '',
  GivenName: '',
  Mail: '',
  Persona: '',
  Surname: '',
};

export const signedInUserReducer = (state = initState, action: any) => {
  switch (action.type) {
    case Actions.SIGN_IN_USER: {
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
